import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { ReverseCollectContext } from '../..';

export const StepButtons = ({ nextFunction }) => {
  const { steps, activeStep, handleBackStep, isSubmitting } = useContext(
    ReverseCollectContext
  );

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 16
      }}
    >
      <Button
        type="button"
        variant="text"
        color="secondary"
        disabled={activeStep === 0 || !!isSubmitting}
        onClick={handleBackStep}
      >
        <MdNavigateBefore size={20} />
        Voltar
      </Button>

      <Button
        type="submit"
        variant={activeStep === steps.length - 1 ? 'contained' : 'text'}
        disabled={!!isSubmitting}
        onClick={nextFunction}
      >
        {activeStep === steps.length - 1 ? (
          <>Concluir</>
        ) : (
          <>
            Próximo
            <MdNavigateNext size={20} />
          </>
        )}
      </Button>
    </Box>
  );
};
